import React, { memo } from "react";
import { AutocompleteOptions } from "@sinch/components/form/AutocompleteInput/types";
import { AutocompleteRenderOptionState } from "@mui/material/Autocomplete/Autocomplete";
import { Checkbox } from "@mui/material";

export const SelectListCheckboxItem = memo(
  ({
    props,
    option,
    state: { selected },
  }: {
    props: React.HTMLAttributes<HTMLLIElement> & { key: any };
    option: AutocompleteOptions;
    state: AutocompleteRenderOptionState;
  }) => {
    const { key, ...optionProps } = props;
    return (
      <li key={key} {...optionProps}>
        <Checkbox checked={selected} color="info" size="small" />
        {option.option}
      </li>
    );
  }
);
SelectListCheckboxItem.displayName = "SelectListCheckboxItem";
